import { postAPICall } from '../../../helpers/httpHelper';
export const fetchAllFiles = async (params) => {
  const response = await postAPICall('GET', 'fileManagement/all-files', params);
  return response?.data || [];
};
export const mapMailTemplateVariables = (
  body,
  allMentionableFields,
  currentEntity,
  revert,
  isFormBuilder
) => {
  const childRegex = /\[\[(.*?)\]\]/g;
  const childVariables = [];
  let match;
  while ((match = childRegex.exec(body)) !== null) {
    childVariables.push(match[1]);
  }
  if (isFormBuilder) {
    allMentionableFields = allMentionableFields.filter(
      (f) => !f?.template_key?.includes('approver/') && !f?.template_key?.includes('folder/')
    );
  }
  // Replace labels with their corresponding template_keys (need to change for other entities labels)
  body = body.replace(/\[\[(.*?)\]\]/g, (match, label) => {
    if (label?.split('#').length == 3) {
      let parts = label.split('#');
      label = `${parts[1]}#${parts[2]}`;
    }
    const template = allMentionableFields.find(
      (obj) => (!revert && obj.label === label) || (revert && obj.id == label)
    );
    let value = '';
    if (revert) {
      value = template?.label;
    } else if (isFormBuilder) {
      value = currentEntity?._id + '#' + template?.template_key;
    } else {
      value = template?.template_key;
    }
    if (template?.input_type == 'PAY_BUTTON') {
      return template ? `[[${value}#pay]]` : match;
    }
    return template ? `[[${value}]]` : match;
  });
  return body;
};

export const getFieldsByType = (types, allFields) => {
  if (types && types.length) {
    if (types.find((e) => e == 'CURRENCY' || e == 'NUMBER')) {
      types.push('CURRENCY');
      types.push('NUMBER');
    }
    return (allFields || []).filter(
      (e) =>
        types.indexOf(e.inputType) != -1 ||
        (e.inputType == 'FORMULA' && types.indexOf(e.result_type) != -1) ||
        (e.inputType == 'AGGREGATE_FUNCTION' &&
          (types.indexOf('NUMBER') != -1 || types.indexOf('CURRENCY') != -1)) ||
        (e.inputType == 'SINGLE_LINE_TEXT' && types.indexOf(e.input_type) != -1)
    );
  }
  return allFields || [];
};

export const getFieldProperty = (fields, key, keyProperty, property = '', defaultValue = '') => {
  if (fields && fields.length && key && keyProperty) {
    let field = fields.find((e) => e && e[keyProperty] == key);
    if (field) {
      if (property) {
        return field[property] ? field[property] : defaultValue;
      }
      return field;
    }
    return defaultValue;
  }
  return defaultValue;
};
